/**
 * Helpers de formato y colores para los comparativos financieros.
 * Centralizados aquí para que todos los sub-tabs usen el mismo criterio.
 */

export const MONTH_LABELS: Record<string, string> = {
  enero: 'Enero', febrero: 'Febrero', marzo: 'Marzo', abril: 'Abril',
  mayo: 'Mayo', junio: 'Junio', julio: 'Julio', agosto: 'Agosto',
  septiembre: 'Sep', octubre: 'Oct', noviembre: 'Nov', diciembre: 'Dic',
};
export const MONTH_KEYS = Object.keys(MONTH_LABELS);

export const money = (v: number) =>
  v.toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });

export const pctFmt = (v: number | null) =>
  v === null ? '—' : `${v >= 0 ? '+' : ''}${v.toFixed(1)}%`;

/**
 * Clases de color para variaciones:
 *  - positivo en INGRESO/UTILIDAD → verde (bueno)
 *  - negativo en INGRESO/UTILIDAD → rojo (malo)
 *  - positivo en GASTOS → rojo (malo, más gasto)
 *  - negativo en GASTOS → verde (bueno, menos gasto)
 */
export function varColor(value: number, tipoCuenta: 'INGRESO' | 'GASTOS' | 'UTILIDAD'): string {
  if (Math.abs(value) < 0.5) return 'text-ink-400';
  const isGood = tipoCuenta === 'GASTOS' ? value < 0 : value > 0;
  return isGood ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400';
}

/** Etiqueta de variación con flecha y color. */
export function varLabel(abs: number, pct: number | null): string {
  const arrow = abs >= 0 ? '▲' : '▼';
  return `${arrow} ${money(Math.abs(abs))} (${pctFmt(pct)})`;
}

export const yearOptions = (baseYear: number) =>
  [baseYear - 2, baseYear - 1, baseYear, baseYear + 1].map((y) => ({ value: String(y), label: String(y) }));

export const monthOptions = MONTH_KEYS.map((k) => ({ value: k, label: MONTH_LABELS[k] }));
